// UI translations (ar default, en, ur). Backend-generated messages stay Arabic (phase later).
import { portalTranslations } from "./portal";
import { sharedTranslations } from "./shared";
import { dashboardTranslations } from "./dashboard";

export const translations = {
  ar: {
    common: { loading: "جارٍ التحميل..." },
    lang: { ar: "ع", en: "EN", ur: "اردو" },
    landing: {
      nav: { login: "تسجيل الدخول", startFree: "ابدأ مجاناً" },
      hero: {
        badge: "تجربة مجانية {days} أيام — بدون بطاقة",
        title: "إدارة أذكى • أداء أفضل",
        subtitle: "WorkZone منصة سعودية متكاملة لإدارة فرق العمل من مكان واحد: الموظفون والوثائق (إقامات، جوازات، عقود، تأمينات) والعُهد والمركبات والحضور والرواتب وأداء المندوبين والأهداف — مع نظام ولاء ومكافآت وعروض شركاء ومشتريات المندوبين، وتنبيهات واتساب تلقائية وقراءة ذكية للوثائق بالذكاء الاصطناعي وبوابة خدمة ذاتية للموظفين. كل شيء في مكان واحد.",
        startTrial: "ابدأ التجربة المجانية",
        whatsapp: "تواصل عبر واتساب",
      },
      features: {
        heading: "كل ما تحتاجه لإدارة وثائق موظفيك",
        sub: "أدوات مصممة للشركات السعودية لتتابع كل وثيقة وكل عهدة في مكان واحد.",
        items: [
          { title: "تنبيهات واتساب تلقائية", desc: "تذكير مبكر وتذكير أخير قبل انتهاء أي إقامة أو جواز أو عقد أو تأمين." },
          { title: "قراءة الوثائق بالذكاء الاصطناعي", desc: "ارفع صورة الوثيقة ويستخرج النظام تاريخ الانتهاء والاسم والإقامة والجنسية تلقائياً." },
          { title: "إدارة العُهد وسلسلة التسليم", desc: "تتبّع الدباب والزي والخوذة بين الموظفين مع سند استلام وتوقيع إلكتروني." },
          { title: "لوحة إحصائيات تفاعلية", desc: "توزيع الجنسيات والمهن وحالات الوثائق، مع فلترة بالفروع وتصدير." },
          { title: "فروع وصلاحيات متعددة", desc: "مدير يرى كل الفروع، ومستخدمون بصلاحية عرض أو تعديل ضمن فروعهم فقط." },
          { title: "تقارير وتصدير Excel", desc: "صدّر كل الموظفين والوثائق والعُهد إلى Excel، واطبع سندات التسليم." },
        ],
      },
      pricing: {
        badge: "باقات الاشتراك",
        heading: "اختر الباقة المناسبة لشركتك",
        sub: "كل الباقات تبدأ بتجربة مجانية 14 يوماً بدون بطاقة. رقِّ باقتك في أي وقت.",
        billingMonthly: "شهري",
        billingAnnual: "سنوي",
        saveTwoMonths: "وفّر شهرين",
        offerEndsIn: "ينتهي العرض خلال",
        limitedOffer: "عرض لفترة محدودة",
        freeTrial14: "تجربة مجانية 14 يوماً",
        discount: "خصم",
        perMonth: "⃁ / شهرياً",
        perYear: "⃁ / سنوياً",
        twoMonthsFreeAnnual: "شهران مجاناً عند الدفع سنوياً",
        mostPopular: "الأكثر طلباً",
        bestValue: "الأوفر",
        perRequest: "حسب الطلب",
        startTrialBtn: "ابدأ التجربة المجانية",
        requestQuote: "اطلب عرض سعر",
        whatsappCta: "استفسر أو اشترك عبر واتساب",
      },
      plans: {
        starter: {
          name: "المبتدئة", tagline: "للمنشآت الصغيرة",
          features: ["حتى 10 موظفين", "مستخدم واحد", "فرع واحد", "إدارة الموظفين", "إدارة الوثائق", "تصدير Excel", "تقارير أساسية", "صلاحيات أساسية", "سجل نشاط لمدة 30 يوم"],
          missing: ["تنبيهات انتهاء الوثائق", "بوابة الموظف الذاتية", "السُّلَف والسندات الإلكترونية", "المخالفات المرورية", "التقييم الأسبوعي A→F", "Dashboard أداء المناديب"],
        },
        business: {
          name: "الأعمال", tagline: "للشركات النامية",
          features: ["حتى 100 موظف", "5 مستخدمين", "إدارة فروع (حتى 5 فروع)", "إدارة الموظفين", "إدارة الوثائق", "تنبيهات انتهاء الوثائق", "بوابة الموظف الذاتية", "السُّلَف والسندات الإلكترونية", "المخالفات المرورية", "التقييم الأسبوعي A→F", "Dashboard أداء المناديب", "إشعارات واتساب", "استيراد وتصدير Excel", "سجل نشاط لمدة 90 يوماً"],
          missing: ["التقارير المخصصة من Excel", "إدارة العُهد", "KPI و Target"],
        },
        professional: {
          name: "الاحترافية", tagline: "للشركات الكبيرة",
          features: ["حتى 300 موظف", "15 مستخدماً", "إدارة فروع (حتى 15 فرعاً)", "كل مزايا باقة الأعمال", "Dashboard أداء المناديب المتقدم", "ربط المناديب برقم rider_id", "التقارير المخصصة من Excel", "دشبورد أنواع المركبات", "KPI و Target", "إدارة العُهد", "تقارير متقدمة جداً", "صلاحيات متقدمة", "سجل نشاط لمدة سنة"],
          missing: [],
        },
        enterprise: {
          name: "المؤسسات", tagline: "للمؤسسات",
          features: ["عدد موظفين غير محدود", "عدد مستخدمين غير محدود", "عدد فروع غير محدود", "جميع مزايا الاحترافية", "تقارير مخصصة", "صلاحيات مخصصة", "دعم مخصص", "مدير حساب"],
          missing: [],
        },
      },
      chooser: {
        title: "اختر نوع الدخول",
        desc: "دخول الشركات والمدراء أو دخول الموظفين.",
        company: "شركة / مدير",
        companySub: "جوال + كلمة مرور أو رمز على الإيميل، أو Google",
        employee: "موظف",
        employeeSub: "بالإقامة أو الرقم الوظيفي",
      },
      phoneLogin: {
        title: "تسجيل الدخول",
        desc: "ادخل بحساب الجوال الذي أنشأه لك المدير، أو عبر Google.",
        phoneLabel: "رقم الجوال",
        passLabel: "كلمة المرور",
        submit: "دخول برقم الجوال",
        forgot: "نسيت كلمة المرور؟",
        or: "أو",
        google: "المتابعة عبر Google",
        warnCreds: "أدخل رقم الجوال وكلمة المرور",
        welcome: "مرحباً",
        loginFail: "تعذّر تسجيل الدخول",
        warnForgot: "أدخل رقم جوالك أولاً ثم اضغط نسيت كلمة المرور",
        resetSent: "تم إرسال طلبك للمدير لإعادة تعيين كلمة المرور",
        resetFail: "تعذّر إرسال الطلب",
      },
      footer: "WorkZone © {year} — للتواصل والاشتراك: واتساب {wa}",
    },
    paywall: {
      title: "انتهت الفترة التجريبية",
      subtitle: "اختر الباقة المناسبة لشركتك وفعّلها عبر واتساب لمتابعة إدارة موظفيك ووثائقك وأدائك.",
      subscribeNow: "اشترك الآن",
      whatsappContact: "تواصل عبر واتساب",
      logout: "تسجيل الخروج",
    },
  },

  en: {
    common: { loading: "Loading..." },
    lang: { ar: "ع", en: "EN", ur: "اردو" },
    landing: {
      nav: { login: "Login", startFree: "Start free" },
      hero: {
        badge: "Free {days}-day trial — no card",
        title: "Smarter Management • Better Performance",
        subtitle: "WorkZone is an all-in-one Saudi platform to run your entire workforce from one place: employees, documents (iqamas, passports, contracts, insurance), custody, vehicles, attendance, payroll, rider performance and targets — plus loyalty & rewards, partner offers and rider reimbursements, with automatic WhatsApp alerts, AI document reading and a self-service employee portal. Everything in one place.",
        startTrial: "Start free trial",
        whatsapp: "Contact via WhatsApp",
      },
      features: {
        heading: "Everything you need to manage your employees' documents",
        sub: "Tools built for Saudi companies to track every document and every custody item in one place.",
        items: [
          { title: "Automatic WhatsApp alerts", desc: "Early and final reminders before any iqama, passport, contract or insurance expires." },
          { title: "AI document reading", desc: "Upload a document photo and the system extracts expiry date, name, iqama and nationality automatically." },
          { title: "Custody & handover chain", desc: "Track bikes, uniforms and helmets between employees with a receipt and e-signature." },
          { title: "Interactive stats dashboard", desc: "Distribution of nationalities, professions and document states, with branch filters and export." },
          { title: "Multiple branches & permissions", desc: "A manager sees all branches; users can view or edit only within their branches." },
          { title: "Reports & Excel export", desc: "Export all employees, documents and custody to Excel, and print handover receipts." },
        ],
      },
      pricing: {
        badge: "Subscription plans",
        heading: "Choose the right plan for your company",
        sub: "All plans start with a 14-day free trial, no card. Upgrade anytime.",
        billingMonthly: "Monthly",
        billingAnnual: "Annual",
        saveTwoMonths: "Save 2 months",
        offerEndsIn: "Offer ends in",
        limitedOffer: "Limited-time offer",
        freeTrial14: "14-day free trial",
        discount: "Save",
        perMonth: "SAR / month",
        perYear: "SAR / year",
        twoMonthsFreeAnnual: "2 months free on annual billing",
        mostPopular: "Most popular",
        bestValue: "Best value",
        perRequest: "Custom pricing",
        startTrialBtn: "Start free trial",
        requestQuote: "Request a quote",
        whatsappCta: "Ask or subscribe via WhatsApp",
      },
      plans: {
        starter: {
          name: "Starter", tagline: "For small businesses",
          features: ["Up to 10 employees", "1 user", "1 branch", "Employee management", "Document management", "Excel export", "Basic reports", "Basic permissions", "30-day activity log"],
          missing: ["Document expiry alerts", "Employee self-service portal", "Advances & e-vouchers", "Traffic violations", "Weekly A–F evaluation", "Riders performance dashboard"],
        },
        business: {
          name: "Business", tagline: "For growing companies",
          features: ["Up to 100 employees", "5 users", "Branch management (up to 5)", "Employee management", "Document management", "Document expiry alerts", "Employee self-service portal", "Advances & e-vouchers", "Traffic violations", "Weekly A–F evaluation", "Riders performance dashboard", "WhatsApp notifications", "Excel import & export", "90-day activity log"],
          missing: ["Custom Excel reports", "Custody management", "KPI & Target"],
        },
        professional: {
          name: "Professional", tagline: "For large companies",
          features: ["Up to 300 employees", "15 users", "Branch management (up to 15)", "All Business features", "Advanced riders performance dashboard", "Rider linking by rider_id", "Custom Excel reports", "Vehicle types dashboard", "KPI & Target", "Custody management", "Very advanced reports", "Advanced permissions", "1-year activity log"],
          missing: [],
        },
        enterprise: {
          name: "Enterprise", tagline: "For enterprises",
          features: ["Unlimited employees", "Unlimited users", "Unlimited branches", "All Professional features", "Custom reports", "Custom permissions", "Dedicated support", "Account manager"],
          missing: [],
        },
      },
      chooser: {
        title: "Choose login type",
        desc: "Company/manager login or employee login.",
        company: "Company / Manager",
        companySub: "Phone + password or email code, or Google",
        employee: "Employee",
        employeeSub: "By iqama or employee number",
      },
      phoneLogin: {
        title: "Login",
        desc: "Log in with the phone account your manager created, or via Google.",
        phoneLabel: "Phone number",
        passLabel: "Password",
        submit: "Login with phone",
        forgot: "Forgot password?",
        or: "or",
        google: "Continue with Google",
        warnCreds: "Enter phone number and password",
        welcome: "Welcome",
        loginFail: "Login failed",
        warnForgot: "Enter your phone first, then tap Forgot password",
        resetSent: "Your reset request was sent to the manager",
        resetFail: "Failed to send request",
      },
      footer: "WorkZone © {year} — Contact & subscribe: WhatsApp {wa}",
    },
    paywall: {
      title: "Your trial has ended",
      subtitle: "Choose the right plan for your company and activate it via WhatsApp to keep managing your employees, documents and performance.",
      subscribeNow: "Subscribe now",
      whatsappContact: "Contact via WhatsApp",
      logout: "Logout",
    },
  },

  ur: {
    common: { loading: "لوڈ ہو رہا ہے..." },
    lang: { ar: "ع", en: "EN", ur: "اردو" },
    landing: {
      nav: { login: "لاگ اِن", startFree: "مفت شروع کریں" },
      hero: {
        badge: "{days} دن کی مفت آزمائش — بغیر کارڈ",
        title: "ہوشیار انتظام • بہتر کارکردگی",
        subtitle: "WorkZone سعودی کمپنیوں کے لیے ایک ہی جگہ سے پوری ورک فورس چلانے کا مکمل پلیٹ فارم: ملازمین، دستاویزات (اقامہ، پاسپورٹ، معاہدے، انشورنس)، سامان/عُہدہ، گاڑیاں، حاضری، تنخواہیں، رائیڈر کارکردگی اور اہداف — ساتھ ہی لائلٹی و انعامات، پارٹنر آفرز اور رائیڈر اخراجات، خودکار واٹس ایپ الرٹس، AI دستاویز ریڈنگ اور ملازمین کے لیے سیلف سروس پورٹل۔ سب کچھ ایک جگہ۔",
        startTrial: "مفت آزمائش شروع کریں",
        whatsapp: "واٹس ایپ پر رابطہ",
      },
      features: {
        heading: "اپنے ملازمین کی دستاویزات کے انتظام کے لیے سب کچھ",
        sub: "سعودی کمپنیوں کے لیے بنائے گئے ٹولز تاکہ ہر دستاویز اور ہر سامان ایک جگہ ٹریک ہو۔",
        items: [
          { title: "خودکار واٹس ایپ الرٹس", desc: "کسی بھی اقامہ، پاسپورٹ، معاہدے یا انشورنس کی میعاد ختم ہونے سے پہلے ابتدائی اور آخری یاد دہانی۔" },
          { title: "AI دستاویز ریڈنگ", desc: "دستاویز کی تصویر اپ لوڈ کریں، سسٹم میعاد، نام، اقامہ اور قومیت خودکار نکال لیتا ہے۔" },
          { title: "سامان اور حوالگی کا انتظام", desc: "ملازمین کے درمیان بائیک، وردی اور ہیلمٹ کو رسید اور الیکٹرانک دستخط کے ساتھ ٹریک کریں۔" },
          { title: "انٹرایکٹو اعداد و شمار ڈیش بورڈ", desc: "قومیتوں، پیشوں اور دستاویزی حالتوں کی تقسیم، برانچ فلٹرز اور ایکسپورٹ کے ساتھ۔" },
          { title: "متعدد برانچیں اور اجازتیں", desc: "منیجر تمام برانچیں دیکھتا ہے؛ صارفین صرف اپنی برانچوں میں دیکھ یا ترمیم کر سکتے ہیں۔" },
          { title: "رپورٹس اور ایکسل ایکسپورٹ", desc: "تمام ملازمین، دستاویزات اور سامان کو ایکسل میں ایکسپورٹ کریں، اور حوالگی رسیدیں پرنٹ کریں۔" },
        ],
      },
      pricing: {
        badge: "سبسکرپشن پلانز",
        heading: "اپنی کمپنی کے لیے موزوں پلان منتخب کریں",
        sub: "تمام پلانز 14 دن کی مفت آزمائش سے شروع ہوتے ہیں، بغیر کارڈ۔ کسی بھی وقت اپ گریڈ کریں۔",
        billingMonthly: "ماہانہ",
        billingAnnual: "سالانہ",
        saveTwoMonths: "2 ماہ بچائیں",
        offerEndsIn: "پیشکش ختم ہونے میں",
        limitedOffer: "محدود وقت کی پیشکش",
        freeTrial14: "14 دن کی مفت آزمائش",
        discount: "رعایت",
        perMonth: "ریال / ماہانہ",
        perYear: "ریال / سالانہ",
        twoMonthsFreeAnnual: "سالانہ ادائیگی پر 2 ماہ مفت",
        mostPopular: "سب سے مقبول",
        bestValue: "بہترین قیمت",
        perRequest: "حسبِ طلب",
        startTrialBtn: "مفت آزمائش شروع کریں",
        requestQuote: "قیمت طلب کریں",
        whatsappCta: "واٹس ایپ پر پوچھیں یا سبسکرائب کریں",
      },
      plans: {
        starter: {
          name: "اسٹارٹر", tagline: "چھوٹے کاروبار کے لیے",
          features: ["10 ملازمین تک", "1 صارف", "1 برانچ", "ملازمین کا انتظام", "دستاویزات کا انتظام", "ایکسل ایکسپورٹ", "بنیادی رپورٹس", "بنیادی اجازتیں", "30 دن کا سرگرمی ریکارڈ"],
          missing: ["دستاویزات کی میعاد کے الرٹس", "ملازم سیلف سروس پورٹل", "ایڈوانس اور الیکٹرانک وائوچرز", "ٹریفک خلاف ورزیاں", "ہفتہ وار A→F تشخیص", "رائیڈرز کارکردگی ڈیش بورڈ"],
        },
        business: {
          name: "بزنس", tagline: "بڑھتی کمپنیوں کے لیے",
          features: ["100 ملازمین تک", "5 صارفین", "برانچ انتظام (5 تک)", "ملازمین کا انتظام", "دستاویزات کا انتظام", "دستاویزات کی میعاد کے الرٹس", "ملازم سیلف سروس پورٹل", "ایڈوانس اور الیکٹرانک وائوچرز", "ٹریفک خلاف ورزیاں", "ہفتہ وار A→F تشخیص", "رائیڈرز کارکردگی ڈیش بورڈ", "واٹس ایپ اطلاعات", "ایکسل امپورٹ اور ایکسپورٹ", "90 دن کا سرگرمی ریکارڈ"],
          missing: ["حسبِ ضرورت ایکسل رپورٹس", "سامان (کسٹڈی) کا انتظام", "KPI اور ٹارگٹ"],
        },
        professional: {
          name: "پروفیشنل", tagline: "بڑی کمپنیوں کے لیے",
          features: ["300 ملازمین تک", "15 صارفین", "برانچ انتظام (15 تک)", "بزنس کے تمام فیچرز", "ایڈوانسڈ رائیڈرز کارکردگی ڈیش بورڈ", "rider_id کے ذریعے رائیڈر لنکنگ", "حسبِ ضرورت ایکسل رپورٹس", "گاڑیوں کی اقسام کا ڈیش بورڈ", "KPI اور ٹارگٹ", "سامان (کسٹڈی) کا انتظام", "انتہائی جدید رپورٹس", "ایڈوانسڈ اجازتیں", "1 سال کا سرگرمی ریکارڈ"],
          missing: [],
        },
        enterprise: {
          name: "انٹرپرائز", tagline: "اداروں کے لیے",
          features: ["لامحدود ملازمین", "لامحدود صارفین", "لامحدود برانچیں", "پروفیشنل کے تمام فیچرز", "حسبِ ضرورت رپورٹس", "حسبِ ضرورت اجازتیں", "مخصوص سپورٹ", "اکاؤنٹ منیجر"],
          missing: [],
        },
      },
      chooser: {
        title: "لاگ اِن کی قسم منتخب کریں",
        desc: "کمپنی/منیجر لاگ اِن یا ملازم لاگ اِن۔",
        company: "کمپنی / منیجر",
        companySub: "فون + پاس ورڈ یا ای میل کوڈ، یا گوگل",
        employee: "ملازم",
        employeeSub: "اقامہ یا ملازم نمبر سے",
      },
      phoneLogin: {
        title: "لاگ اِن",
        desc: "وہ فون اکاؤنٹ استعمال کریں جو آپ کے منیجر نے بنایا، یا گوگل کے ذریعے۔",
        phoneLabel: "فون نمبر",
        passLabel: "پاس ورڈ",
        submit: "فون سے لاگ اِن",
        forgot: "پاس ورڈ بھول گئے؟",
        or: "یا",
        google: "گوگل کے ساتھ جاری رکھیں",
        warnCreds: "فون نمبر اور پاس ورڈ درج کریں",
        welcome: "خوش آمدید",
        loginFail: "لاگ اِن ناکام",
        warnForgot: "پہلے اپنا فون درج کریں پھر پاس ورڈ بھول گئے دبائیں",
        resetSent: "آپ کی درخواست منیجر کو بھیج دی گئی",
        resetFail: "درخواست بھیجنے میں ناکامی",
      },
      footer: "WorkZone © {year} — رابطہ اور سبسکرپشن: واٹس ایپ {wa}",
    },
    paywall: {
      title: "آپ کی آزمائش ختم ہو گئی",
      subtitle: "اپنی کمپنی کے لیے موزوں پلان منتخب کریں اور واٹس ایپ پر فعال کریں تاکہ ملازمین، دستاویزات اور کارکردگی کا انتظام جاری رہے۔",
      subscribeNow: "ابھی سبسکرائب کریں",
      whatsappContact: "واٹس ایپ پر رابطہ",
      logout: "لاگ آؤٹ",
    },
  },
};

translations.ar.portal = portalTranslations.ar;
translations.en.portal = portalTranslations.en;
translations.ur.portal = portalTranslations.ur;

translations.ar.perf = sharedTranslations.ar.perf;
translations.en.perf = sharedTranslations.en.perf;
translations.ur.perf = sharedTranslations.ur.perf;
translations.ar.leave = sharedTranslations.ar.leave;
translations.en.leave = sharedTranslations.en.leave;
translations.ur.leave = sharedTranslations.ur.leave;

translations.ar.dash = dashboardTranslations.ar;
translations.en.dash = dashboardTranslations.en;
translations.ur.dash = dashboardTranslations.ur;
